import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import { DynamicContentCardContent } from 'ui/dynamicContentCard/DynamicContentCardContent';
import { SwitchField, Tab, Tabs, Typography } from 'ui';
import {
  contentCardAccentuate,
  contentCardHeader,
  contentCardHeaderTitle,
} from 'ui/dynamicContentCard/dynamicContentCardCssDefs';

interface GlobalProps {
  className?: string;
  fullBleed?: boolean;
  /** adds a thick blue border to the top of the overall card */
  accentuate?: boolean;
}

interface TabsProps extends GlobalProps {
  index?: number;
  setIndex?: (index: number) => void;
  tabs: string[];
  variant: 'tabs';
}

interface ToggleProps extends GlobalProps {
  index?: 0 | 1;
  setIndex?: (index: number) => void;
  title?: string;
  disableToggle?: boolean;
  variant: 'toggle';
}

interface StaticProps extends GlobalProps {
  title?: string;
  variant?: 'static';
}

type Props = TabsProps | ToggleProps | StaticProps;

export const DynamicContentCard: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  children,
  className = '',
  fullBleed = false,
  variant = 'static',
  accentuate = false,
  ...opts
}) => {
  const [activeIndex, setActiveIndex] = React.useState(0);

  const index = 'index' in opts && opts.index !== undefined ? opts.index : activeIndex;
  const handleTabChange = (_e?: React.ChangeEvent<{}>, value?: number): void => {
    if (value === undefined) {
      return;
    }
    if ('setIndex' in opts && opts.setIndex) {
      opts.setIndex(value);
    } else {
      setActiveIndex(value);
    }
  };

  const content = variant === 'static' ? children : React.Children.toArray(children)[index];
  return (
    <Card variant="outlined" css={accentuate && contentCardAccentuate} className={className}>
      {'title' in opts && (
        <CardContent css={contentCardHeader}>
          <Typography variant="heading2Bold" css={contentCardHeaderTitle}>
            {opts.title}
          </Typography>
          {variant === 'toggle' && (
            <SwitchField
              data-testid="dynamic-content-toggle"
              //  showLabel={false}
              checked={index === 1}
              size="small"
              //  onClick={(checked: boolean) => handleTabChange(undefined, checked ? 1 : 0)}
              disabled={'disableToggle' in opts && opts.disableToggle}
            />
          )}
        </CardContent>
      )}
      {'tabs' in opts && opts.tabs && (
        <Tabs contained={true} value={index} onChange={handleTabChange}>
          {opts.tabs.map((label: string, i: number) => (
            <Tab label={label} key={`${i}-${label}`} />
          ))}
        </Tabs>
      )}
      <DynamicContentCardContent fullBleed={fullBleed}>{content}</DynamicContentCardContent>
    </Card>
  );
};
